import {
  FundListingCalcTypeController,
  FundListingController,
  FundListingType,
} from './fund-listing.controller';

export interface FundListingYieldsController
  extends FundListingController,
    FundListingCalcTypeController {
  fundListingType: FundListingType.YIELDS;
  navAsOfDate: string;
  stdYieldThirtyDayAsofDate: string;
}

export const isFundListingYieldsController = (
  object: any
): object is FundListingYieldsController =>
  object.fundListingType === FundListingType.YIELDS;
